import $store from '../store';
// eslint-disable-next-line import/no-cycle
import $router from '../router';
// eslint-disable-next-line import/no-cycle
import HttpClient from './http';

export const login = async (credentials) => {
  try {
    const resp = await HttpClient.post('auth/login', credentials);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    const { access_token, refresh_token } = resp.data;
    $store.dispatch('auth/setToken', access_token);
    $store.dispatch('auth/setRefreshToken', refresh_token);
    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const logout = async () => {
  $store.dispatch('loading/showLoading');
  const resp = await HttpClient.get('auth/logout');
  if (resp.status === 200) {
    const { access_token, refresh_token } = resp.data;
    $store.commit('reset');
    $store.dispatch('auth/setToken', access_token);
    $store.dispatch('auth/setRefreshToken', refresh_token);
    $store.dispatch('loading/hideLoading');
    $router.push('/login');
  }
};
